import { makeStyles } from '@mui/styles';

const APP_SIDE_DRAWER_WIDTH = 450;

export const useProjectSummaryDrawerStyles = makeStyles({
  drawer: {
    width: APP_SIDE_DRAWER_WIDTH,
    flexShrink: 0,
    marginTop: '80px'
  },

  drawerPaper: {
    width: APP_SIDE_DRAWER_WIDTH,
    paddingTop: '8px'
  }
});
